(function (angular) {
    'use strict';

    angular.module('ui.order.newOrder.addressEditor', [])

        .directive('newOrderAddressEditor', function () {
            return {
                restrict: "E",
                templateUrl: 'app/ui/order/newOrderView/newOrderAddressEditor/newOrderAddressEditor.html',
                scope: {
                    address: "=",
                    onSave: "&",
                    onCancel: "&"
                },
                controller: 'newOrderAddressEditorController'
            };
        })

        .controller('newOrderAddressEditorController', function ($scope, gettextCatalog) {
            angular.extend($scope, {
                onSaveButtonClick: onSaveButtonClick,
                onCancelButtonClick: onCancelButtonClick
            });

            $scope.titles = [
                gettextCatalog.getString('Mr.'),
                gettextCatalog.getString('Ms.'),
                gettextCatalog.getString('Mrs.'),
                gettextCatalog.getString('Dr.')
            ];

            $scope.telephonePattern = "( *\\+)?( *[0-9] *)*(\\(( *[0-9] *)+\\))?( *[0-9]( *- *[0-9])* *)+";

            function onSaveButtonClick() {
                if ($scope.addressEditorValidator.validate()) {
                    $scope.onSave();
                }
            }

            function onCancelButtonClick() {
                $scope.addressEditorValidator.hideMessages();
                $scope.onCancel();
            }
        })
    ;
})(window.angular);
